import { State, Events } from './types';

import { Events as FilteredEvents, FilterBy, SortBy } from '@/studio/studioEventList/store/types';

const mutations = {
  setSeriesFilteredEvents(state: State, filteredEvents: FilteredEvents) {
    state.filteredEvents = filteredEvents;
  },
  setSeriesOnDemandEventIds(state: State, onDemandEventIds: string[]) {
    state.onDemandEventIds = onDemandEventIds;
  },
  setSeriesEventsSearchTerm(state: State, newSearchTerm: string) {
    state.searchTerm = newSearchTerm;
  },
  setSeriesEventsFilterBy(state: State, filterBy: FilterBy) {
    state.filterBy = filterBy;
  },
  setSeriesEventsSortBy(state: State, sortBy: SortBy) {
    state.sortBy = sortBy;
  },
  setIsSeriesEventsLoading(state: State, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  setSeriesEventsCurrentPage(state: State, currentPage: number) {
    state.currentPage = currentPage;
  },
  setSeriesEventsCount(state: State, eventsCount: number) {
    state.eventsCount = eventsCount;
  },
  resetSeriesEventsFilters(state: State) {
    state.filterBy = FilterBy.UpcomingEvents;
    state.sortBy = SortBy.EventDateDescending;
  },
  setEvents(state: State, events: Events) {
    state.events = events;
  },
  setIsFetchingEvents(state: State, isFetchingEvents: boolean) {
    state.isFetchingEvents = isFetchingEvents;
  }
};

export default mutations;
